import React from 'react';
import CustomerSearchPicker from './CustomerSearchPicker';

/**
 * Customer + search filters for the CI Contacts directory. A fork of
 * UsersDirectoryFilters.jsx (kept separate so the existing "Users" page's
 * behavior/markup is untouched) with the customer <select> replaced by a
 * type-ahead search -- preloading every customer into a dropdown doesn't
 * scale past a few hundred, let alone the 2000+ some real accounts have.
 */
export default function ContactsDirectoryFilters({
  siteId,
  filterCustomerId,
  filterCustomerLabel,
  onCustomerSelect,
  onCustomerClear,
  searchDraft,
  onSearchDraftChange,
  onApplySearch,
  loading,
}) {
  return (
    <div className="ci-card mb-3">
      <div className="p-3">
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md-4">
            <label className="form-label mb-1" htmlFor="ci-contacts-customer-filter">
              Customer
            </label>
            <CustomerSearchPicker
              id="ci-contacts-customer-filter"
              siteId={siteId}
              value={filterCustomerId}
              valueLabel={filterCustomerLabel}
              onSelect={onCustomerSelect}
              onClear={onCustomerClear}
            />
          </div>
          <div className="col-12 col-md-5">
            <label className="form-label">Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="Email, name, phone, customer, or site"
              value={searchDraft}
              onChange={(e) => onSearchDraftChange(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') onApplySearch(); }}
            />
          </div>
          <div className="col-12 col-md-3 d-flex justify-content-md-end">
            <button
              type="button"
              className="btn btn-outline-primary"
              disabled={loading}
              onClick={onApplySearch}
            >
              {loading ? 'Searching…' : 'Search'}
            </button>
          </div>
        </div>
        <p className="text-muted small mb-0 mt-2">
          Searches contact email, name, phone, and the owning customer/site name.
        </p>
      </div>
    </div>
  );
}
